export default __webpack_public_path__ + "static/media/screen4.677cb092.jpg";